module.exports = __webpack_public_path__ + "static/media/mysql.8d936f75.jpg";